import { Media } from "../common/media";
import { PARTNER_STATUS } from "shared/enums/common.enum";

export class User {
    id!: string;
    name: string = '';
    email: string = ''
    emailVerified!: boolean;
    stripeConnectAccountId!: string;
    rejectReason: string | null = null;
    rejectedAt: string | null = null;
    rejectedBy: string | null = null;
    profilePic: Media | null = null;
    profilePicId: string | null = null;
    commissionPercent: number = 0;
    status !: PARTNER_STATUS;
    code: string | null = null;
    createdAt!: string;
    updatedAt!: string;

    constructor(data: Partial<User> = {}) {
        Object.assign(this, data);
        if (data.profilePic) this.profilePic = new Media(data.profilePic)
    }
}